/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentAccountFilter/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentAccountFilter({
  children,
  viewPath = "/DesignSystem/PaymentAccount/PaymentAccountFilter",
  labelExisting = "Existing payors",
  labelNew = "New payors"
  
}) {
let selectedFilterValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'filter',
})
let constantData = 'EXISTING'
let aggregateData = fromAggregate.equals(selectedFilterValueData, constantData)
let onClick = fromHelpers.useOnClickExisting({
  children,
  viewPath,
  labelExisting,
  labelNew
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedFilterValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'filter',
})
let constantData1 = 'NEW'
let aggregateData1 = fromAggregate.equals(selectedFilterValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickNew({
  children,
  viewPath,
  labelExisting,
  labelNew
  
})
  return (<React.Fragment
>
<div
  data-testid="PaymentAccountFilter.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PaymentAccountFilter.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="selected.filter"
 data="'EXISTING'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 text={labelExisting}
/>
</div>
<div
  data-testid="PaymentAccountFilter.Horizontal:2"
  data-view-path={viewPath}
 style={{'--ml-1-26aiu5': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="selected.filter"
 data="'NEW'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 text={labelNew}
/>
</div>
</div>
{children}
</React.Fragment>)
}